export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: {
    signUp:"S'inscrire",  
    title: 'Universal wallet for your all digital assets.',
    submit: 'Connexion',
    username: 'Veuillez entrer votre numéro de téléphone',
    password: 'S\'il vous plait entrez votre mot de passe',
    verifycode:'Veuillez saisir le captcha',
    forget_password:'Mot de passe oublié?',
    no_account:'Vous n\'avez pas de compte AuWallet?',
    register:'Registre',
    verifycode_tip:'S\'il vous plaît entrez captcha',
    verifycode_error:'Captcha invalide'
  },
  register:{
    title:'Registre',
    username:'Numéro de téléphone',
    get_code:'Obtenir le code',
    verifycode:'Code de vérification',
    password:'Mot de passe',
    repeat:'Confirmer',
    invite_code:'Code d\'invitation',
    submit:'Registre',
    registered:'Vous avez déjà un compte',
    go_login:'Connectez-vous'
  },
  nologin:{
    cloud_wallet:'Portefeuille Cloud',
    cloud1:'Protection de sécurité supérieure',
    cloud2:'Gain d\'actif unique, enregistrez et déposez des pièces pour profiter des revenus',
    cloud3:'Prend en charge plus de 30+ pièces grand public et 500+ jetons',
    button1:'Registre',
    button2:'Connexion',
    button_oauth: 'Se connecter avec 2U.Chat',
    hd_wallet:'HD Wallet',
    hd1:'100% de contrôle des clés privées, des actifs plus assurés',
    hd2:'Importation de mots mnémoniques en un clic, pratique et facile à utiliser',
    hd3:'Prend en charge plus de 30+ pièces grand public et 500+ jetons',
    button3:'Registre',
    button4:'Connexion',
    doLogin:"Cliquez pour vous connecter",
    welcomeTo:"Bienvenue sur AuWallet",
  },
  forget:{
    title:'Mot de passe oublié？',
    phone_number:'Numéro de téléphone',
    verify_code:'Le code de vérification',
    password:'Mot de passe',
    repeat:'Répète encore',
    submit:'Confirmer'
  },
  footer:{
    nav1:'Portefeuille',
    nav2:'Marché',
    nav3:'Atout',
    nav4:'Découvrir',
    nav5:'Moi'
  },
  home:{
    total:'Total des actifs',
    invite:'Inviter des amis',
    redbag:'Envoyer Redpacket',
    exchange:'Échange',
    scan:'Balayage',
    address_book:'Carnet d\'adresses',
    notice:'Avis',
    setting:'Réglage',
    view_mnemonic:'Vue Mnemonic',
    backup_mnemonic:'Sauvegarde Mnemonic',
    create_wallet:'Créer Portefeuille',
    import_wallet:'Importer Portefeuille',
    welcome:'Bienvenu',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  },
  
  address:{
    new_address:'Nouvelle adresse',
    name:'Nom',
    address:'Adresse',
    submit:'Créer',
	warning_msg: 'Note: Cette adresse ne peut recevoir que des jetons erc20. Veuillez noter de ne pas sélectionner le mauvais canal lors du transfert.'
  },
  swap:{
    title:'Échange de flash',
    pay:'Vous devriez payer',
    balance:'Balance disponible',
    lock_rate:'Veuillez effectuer le paiement dans le délai suivant pour verrouiller ce taux de change',
    gain:'Tu auras',
    input:'Veuillez saisir le montant',
    tip:'Lorsque la devise que vous obtenez est vide, cela signifie qu\'il n\'y a pas de devise à échanger flash',
    submit:'Échanger maintenant',
    choose_coin:'Choisissez la pièce',
	notice_2ut:'j\'ai lu cet avis'
  },
  coin:{
    send:'Envoyer',
    swap:'Échanger',
    receive:'Recevoir',
    transactions:'Transactions',
    type1:'Cloud Dehors',
    type2:'Cloud En',
    type3:'Échanger',
    type4:'La finance',
    type7:'HD Dehors',
    type8:'HD En',
    type9:'Envoyer Red Packet',
    type10:'Accepter Red Packet',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'Rinçage...',
    loading:'Chargement...',
    no_records:'Pas d\'enregistrements',
    wallet:' Portefeuille',
    tx_time:'Heure de la transaction',
    tx_id:'identifiant',
    tx_from:'De',
    tx_to:'À',
    tx_memo:'Remarque',
    tx_status1:'échouer',
    tx_status2:'attendre',
    tx_status3:'Succès',
    tx_status4:'En attente',

    receive_address:'Veuillez saisir l\'adresse de réception',
    balance:'Équilibre',
    fee:'honoraires',
    send_all:'Envoyer tout',
    gas_fee:'Redevance de gaz',
    slow:'lent',
    fast:'jeûner',
    send:'Envoyer',
    tx_password:'Veuillez saisir le mot de passe de paiement',
    tx_remark:'Remarques (facultatif)',
    address_book1:'Carnet d\'adresses cloud',
    address_book2:'HD Carnet d\'adresses',
    need_pay_pass:'Veuillez d\'abord définir le mot de passe de paiement',
    need_pin:'Veuillez vous rendre au centre personnel pour définir le code PIN',

    
    set_receive_amount:'Définir le montant de la réception',
    receive_amount:'Recevoir le montant',
    copy_receive_code:'Copier le code de paiement',
    confirm:'Confirmer',
    cancel:'Résilier',
    rcv_address:'Adresse de réception',
    search:'Entrer le contenu de la recherche',
    filter:'Filtre',
    remove:'Retirer',
    add:'Ajouter',

    filter1:'Toutes les devises',
    filter2:'ajouté',
    filter3:'Non ajouté',
    
    notices:'Avis sur les portefeuilles HD',
    notices2:'Avis relatifs aux portefeuilles cloud',
	only_bitcoin: "Il n'y a que du bitcoin ici.",
	only_eth: 'ETH Trading only here',
	only_usdt: "Il n'y a que des transactions erc20 usdt ici.",
	only_2ut: 'Seules les transactions 2ut sont disponibles ici',
	only_u2u: 'Pièces u2u seulement',
	only_2u: '2u points seulement',
	only_a2u: 'Transmission a2u seulement',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'Marché',
    coin:'Atout',
    volume:'volume',
    price:'prix',
    change:'changer (24H)'
  },

  discover:{
    title:'Découvrir',
    popular:'Populaire',
    all:'Toute'
  },

  my:{
    title:'ma',
    notice:'Avis',
    login:'Cliquez pour vous identifier',
    welcome:'Bienvenue chez AuWallet',
    invite:'Récompense d\'invitation',
    news:'Express quotidien',
    contact:'Service Clientèle',
    pin_on:'SUR',
    pin_off:'DE',
    default_currency:'Devise par défaut',
    red_green:'Options de devis',
    option1:'Vert vers le haut rouge vers le bas',
    option2:'Rouge vers le haut vert vers le bas',
    contract:'Contrat de service',
    privacy:'Politique de confidentialité',
    help:'Centre d\'assistance',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	reenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'Réglage du portefeuille',
    pay_password:'Payer le mot de passe',
    on:'SUR',
    off:'DE',
    google:'Vérification Google',
    security_level:'Niveau de sécurité',
    account_name:'Nom du compte',
    logout:'Déconnexion',
    register_time:'Heure d\'enregistrement',
    level:'Niveau',
    modify_pay_password:'Modifier le mot de passe de paiement',
    reset_pay_password:'Réinitialiser le mot de passe de paiement',
    reset_tip:'Pour la sécurité de votre compte, veuillez saisir le mot de passe de paiement d\'origine pour confirmer votre identité',
    forget_pay_password:'Mot de passe de paiement oublié',
    set_pay_password:'Définir le mot de passe de paiement',
    enter_password:'S\'il vous plaît entrer le mot de passe',
    enter_password2:'Veuillez entrer à nouveau',
    vcode:'Code de vérification',
    submit:'Confirmer',
    pay_password_wrong:'Le mot de passe que vous avez entré est incorrect',
    fontSize:'Taille de police'

  },
  news:{
    title:'Express quotidien',
    share:'Partager',
    good:'Bon',
    bad:'Mauvais'
  },
  pin:{
    title:'Définir le code PIN',
    desc1:'Afin de protéger la sécurité de vos actifs, veuillez d\'abord définir un code PIN, le code PIN sera utilisé pour déverrouiller le portefeuille et envoyer des pièces',
    desc2:'Le code PIN est un mot de passe local, veuillez le conserver correctement, s\'il est perdu, il ne peut pas être récupéré',
    close:'Désactiver le code PIN',
    title2:'Vérifier le NIP',
    tip2_1:'Vous avez oublié votre code PIN ? Après avoir sauvegardé le portefeuille, réinstallez l\'application et réinitialisez après avoir importé la phrase mnémotechnique'
  },
  google:{
    title:'Vérification Google',
    tip:'La vérification en deux étapes de Google peut ajouter une couche de protection à votre compte. Lorsque vous vous connectez ou effectuez une transaction, lorsque vous entrez votre mot de passe, vous avez également besoin d\'un code de vérification de la vérification en deux étapes',
    help:'Comment utiliser la vérification en deux étapes de Google'
  },
  security:{
    title:'Niveau de sécurité',
    title2:'Niveau de sécurité',
    tip:'Pour la sécurité de vos fonds, vous avez besoin de paramètres de sécurité supplémentaires et d\'informations de nom réel avant de pouvoir retirer des pièces, et la limite de retrait augmentera en conséquence.',
    l3title:'Sélectionnez le type de document',
    l3tip:'Veuillez sélectionner le pays d\'émission de votre certificat',
    c1:'Amérique',
    c2:'Chine continentale',
    c3:'Chine Hong Kong, Macao et Taïwan',
    c4:'Corée du Sud',
    c5:'Japon',
    c6:'Singapour',
    c7:'Autre',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'Informations sur la certification',
    tip:'AuWallet vous oblige à soumettre une pièce d\'identité avec photo émise par le gouvernement pour passer la vérification de sécurité',
    subtitle1:'Formulaire d\'abonnement 2U Token (2UT)',
    country:'Pays',
    country_hint:'Votre pays de résidence',
    firstname:'Prénom',
    firstname_hint:'Ton prénom',
    surname:'Nom',
    surname_hint:'Votre Nom',
    birthdate:'Date d\'anniversaire',
    cert_id:'Numéro d\'identité',
    cert_id_hint:'Votre numéro d\'identité',
    id_photo1:'Photo d\'identité de face',
    id_photo2:'Photo d\'identité inversée',
    address:'Adresse',
    address_hint:'Votre résidence actuelle',
    addr_photo:'Justificatif de domicile',
    asset_photo:'Preuve d\'actifs',
    subtitle2:'Certificat de qualification d\'investisseur',
    tip1:'Je confirme que je réponds à au moins un des critères suivants et que j\'ai été certifié en tant qu\'investisseur qualifié par l\'émetteur (le cas échéant, plusieurs peuvent être sélectionnés)',
    tip2:'Note (1) : Le portefeuille d\'investissement se réfère aux titres et à la trésorerie, hors immobilier.',
    tip3:'Note (2) : Les documents qui ont un relevé mensuel, un résumé des calculs, etc. doivent être joints au cours des trois derniers mois',
    invest_exp:'Expérience en investissement',
    other_exp:'Autre',
    avg_volume:'Volume',
    avg_volume_hint:'Volume de transaction moyen au cours des 12 derniers mois (USD)',
    avg_num:'Nombre',
    avg_num_hint:'Nombre moyen de transactions au cours des 12 derniers mois',
    exp_year:'Années d\'investissement',
    exp_year_hint:'Combien d\'années d\'expérience en investissement',
    net_asset:'Actif net',
    net_asset_hint:'Valeur d\'actif net (USD)',
    risk_tolerance:'Tolérance au risque',
    invest_term:'Durée d\'investissement idéale',
    derivative:'Dérivé',
    signature:'Signature',
    reset:'Réinitialiser',
    phone_number:'Numéro de téléphone',
    submit:'Soumettre',
    option1_1:'Particuliers ou investisseurs particuliers fortunés détenant un portefeuille d\'espèces et/ou de titres d\'au moins 20 000 USD (ou l\'équivalent) dans un compte conjoint avec leur conjoint ou leurs enfants',
    option1_2:'Le portefeuille d\'investissement de l\'entreprise ou du partenariat n\'est pas inférieur à 20 000 USD ou l\'actif total n\'est pas inférieur à 2 millions USD',
    option1_3:'Les investisseurs individuels fortunés, les entreprises ou les partenariats ouvrent un compte auprès de De La O RuralBank Inc. et disposent d\'au moins 20 000 USD au moment de signer ce formulaire d\'évaluation',
    option2_1:'Titres',
    option2_2:'Futures',
    option2_3:'Placement',
    option2_4:'Autre (veuillez préciser)',
    option3_1:'Haut',
    option3_2:'Moyen',
    option3_3:'Bas',
    option4_1:'Plus que 3 ans',
    option4_2:'1-3 ans',
    option4_3:'Moins de 1 an',
    option5_1:'Oui',
    option5_2:'Non'
  },
  envelope:{
    title:'Enveloppe rouge',
    owned:'Mon Enveloppe',
    amount:'Montant',
    quantity:'Quantité',
    quantity_hint:'Quantité d\'enveloppe',
    generate:'Générer',
    title2:'Envoyer l\'enveloppe',
    total:'Montant total de l\'enveloppe rouge',
    wishes:'Souhaits',
    submit:'Paie',
    enter_pass:'Veuillez entrer le mot de passe de paiement',
    choose_path:'Choisissez un mode de livraison',
    view:'Voir le détail de l\'enveloppe rouge',
    choose_coin:'Choisir coin',
    need_pay_password:'Veuillez d\'abord définir le mot de passe de paiement',
    share:'Partagez l\'enveloppe rouge avec vos amis',
    title3:'Dossiers de l\'enveloppe rouge',
    num:'Quantité'
  },
  mnemonic:{
    title:'Portefeuille de sauvegarde mnémonique',
    tip:'Le mnémonique est la clé privée, qui est la clé pour contrôler votre propriété',
    tip1:'1. Il se compose de 12 caractères, veuillez le copier et le conserver en lieu sûr.',
    tip2:'2. 100% sera conservé par vous, une fois perdu, il ne pourra pas être récupéré.',
    tip3:'3. Veuillez vous assurer de terminer la sauvegarde de la phrase mnémotechnique avant de recevoir la devise ou de la désinstaller.',
    backup:'Sauvegarder maintenant',
    later:'Fais-le plus tard',
    tip4:'Veuillez regarder autour de vous',
    tip5:'Quiconque obtient le mnémonique signifie qu\'il a obtenu vos actifs. Veuillez vous assurer qu\'il n\'y a personne autour et pas de caméras.',
    understand:'Entendu',
    title2:'Voir Mnémonique',
    tip6:'Vous pouvez importer la phrase mnémonique à coupler sur d\'autres appareils ou utiliser le portefeuille AuWallet sur d\'autres appareils pour scanner le code QR à coupler.',
    tip7:'Merci de ne pas faire de capture d\'écran ! Si quelqu\'un obtient votre phrase mnémonique, il obtiendra directement vos actifs !',
    view_code:'Voir le code QR chiffré',
    tip8:'Le cryptage du code QR permet de faciliter le couplage du portefeuille avec de nouveaux appareils. Veuillez ne pas prendre de captures d\'écran et les enregistrer, et assurez-vous qu\'il n\'y a personne autour ou de caméras cachées.',
    tip9:'Ce code QR ne peut être utilisé que par les portefeuilles AU. Lors de la numérisation, vous devez entrer le code PIN de l\'APP actuelle dans l\'APP à importer pour importer avec succès le mnémonique correspondant.',

    title3:'Veuillez copier le mnémonique AuWallet',
    tip3_1:'La phrase mnémotechnique AuWallet est utilisée pour restaurer le portefeuille. Veuillez copier les 12 mots suivants sur papier dans l\'ordre et les conserver en lieu sûr.',
    tip3_2:'S\'il vous plaît, ne faites pas de capture d\'écran ! Si quelqu\'un obtient votre phrase mnémotechnique, il obtiendra directement vos actifs !',
    save:'je l\'ai sauvegardé en toute sécurité',

    title4:'Veuillez confirmer la phrase mnémotechnique AuWallet',
    tip4_1:'Afin de vous assurer que vous avez correctement copié les mots mnémoniques AuWallet, veuillez sélectionner le mot correspondant au numéro de série.',
    finish:'Fini',
    next:'Prochain',
    verror:'Erreur de validation',

    title5:'Restaurer le portefeuille mnémotechnique',
    tip5_1:'Veuillez saisir les mots mnémotechniques dans le formulaire ci-dessous pour répondre au portefeuille. Après chaque mot mnémonique est entré, appuyez sur la touche "espace" pour passer au mot suivant',
    recover:'Démarrer la récupération',
    ask:'Écraser le portefeuille actuel?',
    tip5_2:"L'importation d'un portefeuille écrasera le portefeuille actuel. Si vous n'avez pas encore sauvegardé, le portefeuille actuel disparaîtra pour toujours.",
    tip5_3:'J\'ai sauvegardé mon portefeuille actuel et j\'accepte de l\'écraser',
    cancel:'Annuler',
    import:'Continuer l\'importation',
    agree:'Veuillez choisir d\'accepter',
    create_success:'Créé avec succès',
    complete:'Veuillez remplir le mnémonique complet'
  },
  invite:{
    title:'Mon invitation',
    total:'Numéro de convocation',
    invite_num:'Nombre d\'amis enregistrés',
    bonus1:'Amis de niveau 1',
    every:'p.p',
    bonus2:'Amis de niveau 2',
    bonus3:'Amis de niveau 3',
    deposit:'Nombre d\'amis déposant des coin',
    list:'Liste d\'invitations',
    subtitle1:'Enregistrement',
    subtitle2:'Dépôt',
    no_records:'Pas encore d\'invitation'
  },
  lang:{
    set_lang:'Définir la langue',

  },
  setting:{
    tip:"Le système négocie en fait en dollars américains et le système convertit automatiquement le prix de la commission de l'utilisateur en dollars américains au dernier taux de change. Le prix réel de la commission peut être légèrement différent du prix d'entrée de l'utilisateur"
  },
  send:{
    title:'Type de transfert',
    t1:'Transfert de blockchain',
    t2:'Transfert interne',
  },
  sortable:{
    title:'Tri personnalisé',
    drag_to_sort:'Faites glisser pour trier',
    currency:'Devise'
  },
  system:{
    flushing:'Rinçage...',
    loading:'Chargement...',
    btn1:'Confirmer',
    btn2:'Annuler',
    add:'Ajouter',
    search:'Chercher',
    topPullText:'Tirez vers le bas pour rafraîchir',
    topDropText:'Actualiser la version',
    topLoadingText:'Chargement...',
    copy_succ:'Copier avec succès',
    copy_fail:'Échec de la copie',
    about:'About'
  },

  share:{
    title:'Partager',
    download:'Scannez le code pour télécharger AuWallet',
    sharecode:'Code d\'invitation (cliquez pour copier):',
    view_invites:'Afficher les détails de l\'invitation',
    copy_link:'Copier le lien',
      attention:'Copiez le lien ci-dessus, collez-le dans votre navigateur mobile et ouvrez-le pour télécharger AuWallet.'
  },
  wealth:{
    tit:"Actifs",
    title:'Ma richesse',
    title1:'Exploitation minière',
    title2:'Plan de pièces',
    hot:'Recommandation populaire',
    plan1:'Forfait à la demande',
    plan2:'Forfait fixe',
    annu_return:'rendement annualisé',
    in_amount:'montant en',
    transfer_all:'toute',
    view_rules:'voir les règles',
    pay_password:'Veuillez saisir le mot de passe de paiement',
    asset:'Richesse',
    search:'Demande de transaction',
    rules:'des règles',
    order_time:'temps de commande',
    value_date:'date de valeur',
    expiry_date:'date d\'expiration',
    highlights:'points forts',
    remaining_quota:'quota restant',
    buy:'Acheter maintenant',
    ystday_earnings:"les gains d'hier",
    total_earnings:'Total des gains',
    transfer_in:'dans',
    transfer_out:'en dehors',
	transfer_outed:'Racheté',
    tran_all:'toute',
    tran_in:'dans',
    tran_out:'en dehors',
    tran_earning:'gagner un revenu',
    prod_all:'toute',
    prod1:'Minage de point de vente',
    prod2:'Plan de pièces',
    curr_all:'toute',
    out_amount_tip:'Veuillez saisir le montant du virement',
    send:'Envoyer',
    success:'Succès',
    amount_tip:'Veuillez entrer un montant',
  },
  ads:{
    title:'Bonnes nouvelles',
    content:"U2U est en train d'être racheté",
    content2:'2UT Hot selling...',
    buy:'acheter',
    plan_name:'U2U Nouveau numéro',
    tip: 'U2U is 10% off!'
  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
	  fuzhicg:'Copie réussie.',
	  fuzhicc:'La réplication a échoué.',
  },
  alert:{
  	  cancel:'Annulation',
  	  confirm:'Confirmation'
  },
  against:{
		  no100: "L'usdt doit être un multiple de 100"
	},
	package:{
		  title: 'Colis',
		  amount: 'Nombre',
		  time: 'Temps',
		  coin: 'Token',
		  price: 'Prix',
		  scale: 'Taille',
		  quantity: 'Quantité',
		  submit: 'Présentation',
		  total: 'Tous',
		  points: 'Pointage',
		  apoints2: 'Revenu disponible de la richesse',
		  balance: 'Équilibre',
		  apoints: 'Nombre de points disponibles:',
		  abalance: 'Solde disponible(USDT):',
		  abalance2: 'Solde disponible(U2U):',
		  import: 'Importations',
		  orders: 'Ordre',
		  orders_detail: 'Détails de la commande',
		  defi: 'DEFI',
		  nopoint: 'échanger plus que les points disponibles',
		  nobalance: 'Remboursement supérieur au solde disponible',
		  nologin: 'La connexion a expiré, veuillez vous connecter à nouveau.',
		  pay_type: 'Type de paiement'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
}